import { useContext } from "react";
import { CartContext } from "../cartcontext";
import PayPalButton from "../PayPalButton";

const Cart = () => {
  const { cart, total, removeFromCart, addToCart, decreaseQty } =
    useContext(CartContext);

  return (
    <main className="cart-page container">
      <h2 className="mb-4 fw-bold">Tu carrito</h2>

      {cart.length === 0 && <p>No hay productos aún</p>}

      {cart.map((item, i) => (
        <div className="cart-item" key={item.name}>
          <div className="cart-product-info">
            <img src={item.image} alt={item.name} className="cart-img" />

            <div>
              <h6 className="mb-1">{item.name}</h6>
              <small className="text-muted">${Number(item.price).toFixed(2)}</small>
            </div>
          </div>

          <div className="cart-qty-controls">
            <button
              type="button"
              className="qty-btn"
              onClick={() => decreaseQty(item.name)}
              aria-label={`Quitar uno de ${item.name}`}
            >
              −
            </button>

            <span>{item.qty}</span>

            <button
              type="button"
              className="qty-btn"
              onClick={() => addToCart(item)}
              aria-label={`Agregar uno de ${item.name}`}
            >
              +
            </button>
          </div>

          <div className="cart-subtotal">
            <strong>${(Number(item.price) * item.qty).toFixed(2)}</strong>

            <button
              type="button"
              className="remove-btn"
              onClick={() => removeFromCart(i)}
            >
              Eliminar
            </button>
          </div>
        </div>
      ))}

      <div className="cart-total-box">
        <h4>Total: ${total.toFixed(2)}</h4>

        {cart.length > 0 && (
          <div className="paypal-wrapper">
            <PayPalButton total={total} />
          </div>
        )}
      </div>
    </main>
  );
};

export default Cart;
